import type { Auth0Options, GlobalImport } from '../shared/interfaces';
import { toFeedback } from '../shared/to-feedback';

import { afterSuccessAction } from './shared/after-success-action';
import { FormWidgetBase } from './shared/form-widget-base';
import { getAuth0Client } from './shared/get-auth0-client';
import { recaptchaReady } from './shared/recaptcha-ready';
import { requestWithRecaptchaV3 } from './shared/request';
import { getAuth0AuthenticatedClient } from './shared/setup-auth0';

class ChangeToSavePlanWidget extends FormWidgetBase {
    override requiredImports: GlobalImport[] = [`auth0`, `recaptchaV3`];

    override async afterConnected() {
        const [auth0Script] = await this.importing;
        if (!auth0Script) {
            this.feedback.innerHTML += `Your browser has failed to load script responsible for authorization.`;
            return;
        }

        const widgetConfig = this.config as Auth0Options;

        if (widgetConfig.auth0 !== false) {
            await getAuth0AuthenticatedClient().catch((err) => {
                toFeedback([err.message], this.feedback);
                throw err;
            });
        }

        this.button.disabled = false;
        this.loader.classList.add(`invisible`);
    }

    async submit(info: any) {
        const widgetConfig = this.config as Auth0Options;
        let accessToken: string | undefined;

        if (widgetConfig.auth0 !== false) {
            const auth0Client = await getAuth0Client(this.publicConfig);
            accessToken = await auth0Client.getTokenSilently();
        }

        await recaptchaReady();
        const changeToSavePlanResponse = await requestWithRecaptchaV3({
            apiUrl: window.mh.apiUrl,
            endpoint: `/v1/programs/${window.mh.programSlug}/my-subscription/save-plan`,
            method: `PUT`,
            recaptchaV3SiteKey: this.publicConfig.integrations.recaptchaV3.siteKey,
            ...(accessToken && {
                headers: {
                    authorization: `Bearer ${accessToken}`,
                },
            }),
        });

        if (!changeToSavePlanResponse.ok) {
            const json = await changeToSavePlanResponse.json();
            throw new Error(json.error.message ?? json.error);
        }

        if (`afterSuccess` in this.config) {
            afterSuccessAction(this.config.afterSuccess, info);
        }
    }
}

customElements.define(`mh-change-to-save-plan`, ChangeToSavePlanWidget);

export default ChangeToSavePlanWidget;
